(function notificationDefinition() {
    'use strict';
    angular.module('Entities')
        .service('notificationService', [
            'restUrlBuilder', 'authExtend','config', function notificationService(restUrlBuilder, authExtend, config) {
                restUrlBuilder = restUrlBuilder('notif');

                this.getById = function getById(id) {
                    return restUrlBuilder.one('Templates', id).get();
                };

                this.getNotification = function getNotification(type, ou, userId, statePending) {
                    var params = {
                        type: type,
                        organizationalUnitId: ou,
                        userId: userId,
                        statePending: statePending,
                        forAppId: config.appId()
                    }

                    return restUrlBuilder.all('Notifications').get({ params: params });
                };

                this.getTemplates = function getTemplates(app, type, ou) {
                    var params = {
                        application: app,
                        organizationalUnitId: ou,
                        type: type
                    }

                    return restUrlBuilder.all('Templates').get({ params: params });
                };

                this.approve = function approve(notificationId) {
                    if (notificationId == null)
                        throw "El Id de la notificación no puede ser null";

                    return restUrlBuilder.one('Notifications/approve', notificationId ).put();
                };
            }
        ]);
})();